export default "__VITE_ASSET__D0u$VJ6b__"